import axios from 'axios';

import { CompanyInfo } from 'interfaces/components/dataEntryModal';
import { setAuthCookie } from 'services/authService';

export const sendDataAuth = async (dataEntry: CompanyInfo<number>) => {
  await setAuthCookie();

  return axios.post('/api/sendDataAuth', { ...dataEntry });
};
